export default __webpack_public_path__ + "static/media/Agnieszka.adafde50.jpg";